import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grants-letter-of-intent',
  templateUrl: './grants-letter-of-intent.component.html',
  styleUrls: ['./grants-letter-of-intent.component.scss']
})
export class GrantsLetterOfIntentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
